import { render, staticRenderFns } from "./WorkerView.vue?vue&type=template&id=0f180725&scoped=true"
import script from "./WorkerView.vue?vue&type=script&lang=js"
export * from "./WorkerView.vue?vue&type=script&lang=js"
import style0 from "./WorkerView.vue?vue&type=style&index=0&id=0f180725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f180725",
  null
  
)

export default component.exports